import { SearchBar } from '@/pages/Organizations/components/SearchBar/SearchBar';

interface VolunteersSubToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  searchPlaceholder?: string;
}

export function VolunteersSubToolbar({
  search,
  onSearchChange,
  searchPlaceholder = 'Search volunteers by name or department...',
}: VolunteersSubToolbarProps) {
  return (
    <SearchBar value={search} onChange={onSearchChange} placeholder={searchPlaceholder} />
  );
}
